import { useMemo } from 'react';
import _, { merge } from 'lodash';
import { useParams } from 'react-router-dom';
import { useDataService } from '../../../services/ApiDataService';
import { WAN_INTERFACE_CONFIG_API_URL } from '../wan-interface/WanInterfaceAdminConstants';
import { convertLoadParamsToQueryParams, convertQueryResponse, mergeLoadParams } from '../../data-table/Loaders';
import { addPlmPrefix } from '../../../utilities/PgmUtilities';
import { useFormQueryService } from '../../../services/FormQueryService';
import { WAN_META_ADDS_FIELD, WAN_META_FIELD } from './SiteAdminConstants';

export function removeIds(ids, idsToRemove) {
    if (_.isEmpty(ids) || _.isEmpty(idsToRemove)) {
        return ids;
    }

    return _.difference(ids, idsToRemove);
}

export function useSelectedWanLoader(dataSource, selected) {
    const dataService = useDataService();
    return useMemo(() => {
        if (!dataSource) {
            return null;
        }

        return (loaderParams) => {
            const { url, params: datasourceParams } = dataSource;
            const queryParams = merge({}, datasourceParams, convertLoadParamsToQueryParams(loaderParams));

            return dataService
                .post(
                    url,
                    {
                        query: {
                            _id: { $in: selected },
                            deleted: { $ne: true },
                        },
                        siteTmpParams: {
                            siteId: _.get(dataSource, 'params.site'),
                            manualAddIds: _.get(dataSource, `params.${WAN_META_FIELD}.${WAN_META_ADDS_FIELD}`, []),
                        },
                    },
                    queryParams
                )
                .then((response) => convertQueryResponse(dataSource, response));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataSource, selected]);
}

export function useAvailableWanLoader(dataSource, selected) {
    const formQueryService = useFormQueryService();
    const { plmId } = useParams();

    return useMemo(() => {
        return (loaderParams) => {
            const { url, params: datasourceParams } = dataSource;
            const prefixedUrl = addPlmPrefix(url, plmId);
            const queryParams = mergeLoadParams({}, datasourceParams, loaderParams);
            const body = dataSource.body || {};
            const postBody = {
                ...body,
                query: {
                    _id: { $nin: selected },
                    deleted: { $ne: true },
                    pollingStatus: { $ne: 'Disabled' },
                },
            };
            return formQueryService
                .queryAPIPost(prefixedUrl, postBody, {}, queryParams)
                .then((response) => convertQueryResponse(dataSource, response));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataSource, plmId, selected]);
}

function service(dataService) {
    function queryWanInterfaceConfig() {
        return dataService.get(WAN_INTERFACE_CONFIG_API_URL).then((response) => {
            if (_.isArray(response)) {
                return _.first(response);
            }

            return response;
        });
    }

    function queryWanInterfaceIds(rules) {
        const separator = ';';
        return dataService.get('/query/waninterface', {
            ipScopes: _.map(rules, (rule) => rule.valueDisplay).join(separator),
        });
    }

    return {
        queryWanInterfaceConfig,
        queryWanInterfaceIds,
    };
}

export function useWanHelperService() {
    const dataService = useDataService();
    return useMemo(() => service(dataService), [dataService]);
}
